import { FinancialInstitutionsRequest, FinancialInstitutionsResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

type ReturnTuple = [
  FinancialInstitutionsResponse | undefined,
  (params: FinancialInstitutionsRequest) => Promise<FinancialInstitutionsResponse>,
  () => void,
];

// Tuple-shaped like the legacy portal hook the pay dialogs were written
// against; the implementation is the Direct Pattern (no withApiHook).
export default function useFetchFinancialInstitutions(_props: Record<string, never>): ReturnTuple {
  const api = useApi();
  const [response, setResponse] = useState<FinancialInstitutionsResponse>();

  async function fetchFinancialInstitutions(params: FinancialInstitutionsRequest) {
    try {
      const res = await api.fetchFinancialInstitutions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setResponse(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return [response, fetchFinancialInstitutions, () => setResponse(undefined)];
}
